import { Project } from '../../../entities/task/model/types/tasks';
import { SelectedItem } from '../types/taskHeader';

export const getProjectAndEstimates = (projectsForFilter: Project[]): SelectedItem[] => {
    const result: SelectedItem[] = [];
    projectsForFilter.forEach((project) => {
        result.push({
            id: project.id,
            title: project.name,
            isProject: true,
        });
        project.estimates.forEach((estimate) => {
            if (estimate) {
                result.push({
                    id: estimate.id,
                    title: estimate.name,
                    isProject: false,
                    projectId: project.id,
                });
            }
        });
    });

    return result;
};
